export default __webpack_public_path__ + "./image/ce21aaa439043f5ec7a9c966b2959a2f.png";